import { render, staticRenderFns } from "./InspirationModal.vue?vue&type=template&id=0bc8c08c"
import script from "./InspirationModal.vue?vue&type=script&lang=ts"
export * from "./InspirationModal.vue?vue&type=script&lang=ts"
import style0 from "./InspirationModal.vue?vue&type=style&index=0&id=0bc8c08c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports